import React, { useState } from 'react'
import WelcomeMessage from '../../subComponents/WelcomeMessage'
import TopHeader from '../../subComponents/TopHeader'
import styled from 'styled-components'
import SidebarContainer from '../../subComponents/Sidebar/SidebarContainer'

export const HeaderContainer = styled.header`
  /* position: relative; */
`

export default function Header() {
    const [sidebar, setSidebar] = useState(false);
    const toggleSidebar = () => setSidebar(prev => !prev);
    return (
      <HeaderContainer>
        <WelcomeMessage/>
        <TopHeader toggleSidebar={toggleSidebar} />
        <SidebarContainer toggleSidebar={toggleSidebar} sidebar={sidebar}/>
      </HeaderContainer>
    )
}
